import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/salesItemTypes', request)
}

export {get}
